import React, { useEffect } from 'react';
import { useAuth } from '../services/AuthContext';

/**
 * Loud, impossible-to-miss strip shown on every page of a PRACTICE server.
 * Reads app_env from AuthContext (which asks /api/health at load), so it
 * appears before login too.
 */
export default function PracticeBanner({ compact = false, fixed = false }: { compact?: boolean; fixed?: boolean }) {
  const { isPractice } = useAuth();

  useEffect(() => {
    if (!isPractice) return;
    const prev = document.title;
    document.title = `PRACTICE · ${prev.replace(/^PRACTICE · /, '')}`;
    return () => { document.title = prev; };
  }, [isPractice]);

  if (!isPractice) return null;
  return (
    <div
      role="status"
      className={`${fixed ? 'fixed top-0 inset-x-0 z-[60]' : 'w-full'} bg-amber-400 text-amber-950 dark:bg-[#fbbf24] dark:text-[#451a03] text-center font-semibold tracking-wide ${compact ? 'text-[11px] py-1' : 'text-xs sm:text-sm py-1.5'} px-3`}
      style={{ backgroundImage: 'repeating-linear-gradient(135deg, rgba(0,0,0,0.06) 0 12px, transparent 12px 24px)' }}
    >
      PRACTICE MODE — fake clients and jobs. Nothing here is real: no texts, no charges, no bank.
    </div>
  );
}
